export enum RegulatoryTradeIDType {
  Current = 0,
  Previous = 1,
  Block = 2,
  Related = 3,
  ClearedBlockTrade = 4,
  TradingVenueTransactionIdentifier = 5,
  ReportTrackingNumber = 6,
}
